import React, { useEffect } from "react";
import { Divider } from "@mui/material";
import Header from "../components/Header";
import Footer from "../components/Footer";


const Socios = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Header active="partners" />
            <section style={{ width: "100%", height: "60vh", display: "flex", justifyContent: "center", alignItems: "center", background: "linear-gradient(135deg, #ffffff 70%, #0062A6 100%)" }}>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "20px", maxWidth: "700px", textAlign: "center" }}>
                    <h1 style={{ fontSize: "3rem" }}>Nossa liderança</h1>
                    <p>Conheça os sócios que impulsionam nossa visão e definem a estratégia para o futuro da inovação</p>
                </div>
            </section>

            <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "40px" }}>
                <div style={{ width: "80%", display: "flex", justifyContent: "space-between", marginBottom: "80px", flexWrap: "wrap", gap: "20px" }}>
                    <div
                        style={{
                            width: "300px",
                            borderRadius: "16px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                            backgroundColor: "#fff",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                            cursor: "pointer",
                        }}
                    >
                        {/* Imagem */}
                        <div style={{ width: "100%", height: "300px" }}>
                            <img
                                src="assets/socio1.png"
                                alt="Rafael Gonçalves"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "16px 16px 0 0",
                                }}
                            />
                        </div>

                        {/* Conteúdo */}
                        <div style={{ padding: "20px", textAlign: "center" }}>
                            <b style={{ fontSize: "18px", color: "#003c81" }}>
                                RAFAEL GONÇALVES
                            </b>

                            <p
                                style={{
                                    margin: "6px 0 12px",
                                    fontSize: "14px",
                                    color: "#666",
                                    fontWeight: "500",
                                }}
                            >
                                Diretor Comercial e Relações Institucionais
                            </p>

                            <Divider sx={{ margin: "12px 0" }} />

                            <ul
                                style={{
                                    paddingLeft: "18px",
                                    textAlign: "left",
                                    fontSize: "13.5px",
                                    color: "#444",
                                    lineHeight: "1.6",
                                }}
                            >
                                <li>Mestre em Direito Econômico e Desenvolvimento – IDP/Brasília-DF.</li>
                                <li>Especialista em Direito Tributário – IBET/Curitiba.</li>
                                <li>Pós-Graduado em Processo Tributário Analítico – IBET/São Paulo.</li>
                                <li>Pós-Graduado em Planejamento Tributário – IBET/São Paulo.</li>
                                <li>Pós-Graduado em Planejamento Tributário – IBMEC.</li>
                                <li>Pós-Graduado em Gestão Contábil Tributária – UFPR.</li>
                                <li>Direito Fiscal Internacional – Universidade de Direito de Lisboa (UDL).</li>
                            </ul>
                        </div>
                    </div>

                    <div
                        style={{
                            width: "300px",
                            borderRadius: "16px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                            backgroundColor: "#fff",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                            cursor: "pointer",
                        }}
                    >
                        {/* Imagem */}
                        <div style={{ width: "100%", height: "300px" }}>
                            <img
                                src="assets/socio2.jpeg"
                                alt="Ruy Trevisan"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "16px 16px 0 0",
                                }}
                            />
                        </div>

                        {/* Conteúdo */}
                        <div style={{ padding: "20px", textAlign: "center" }}>
                            <b style={{ fontSize: "18px", color: "#003c81" }}>
                                RUY TREVISAN
                            </b>

                            <p
                                style={{
                                    margin: "6px 0 12px",
                                    fontSize: "14px",
                                    color: "#666",
                                    fontWeight: "500",
                                }}
                            >
                                Diretor Jurídico
                            </p>

                            <Divider sx={{ margin: "12px 0" }} />

                            <ul
                                style={{
                                    paddingLeft: "18px",
                                    textAlign: "left",
                                    fontSize: "13.5px",
                                    color: "#444",
                                    lineHeight: "1.6",
                                }}
                            >
                                <li>Mestre em Direito Econômico e Desenvolvimento – IDP/Brasília-DF.</li>
                                <li>Pós-Graduando em Direito Empresarial – Societário e Novos Negócios – FAE Business School.</li>
                                <li>Direito Fiscal Internacional – Universidade de Direito de Lisboa (UDL).</li>
                                <li>Graduação em Direito – Centro Universitário Curitiba.</li>
                            </ul>
                        </div>
                    </div>


                    <div
                        style={{
                            width: "300px",
                            borderRadius: "16px",
                            boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
                            backgroundColor: "#fff",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease",
                            cursor: "pointer",
                        }}
                    >
                        {/* Imagem */}
                        <div style={{ width: "100%", height: "300px" }}>
                            <img
                                src="assets/socio3.png"
                                alt="Edemilso Cordeiro"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "16px 16px 0 0",
                                }}
                            />
                        </div>

                        {/* Conteúdo */}
                        <div style={{ padding: "20px", textAlign: "center" }}>
                            <b style={{ fontSize: "18px", color: "#003c81" }}>
                                EDEMILSO CORDEIRO
                            </b>

                            <p
                                style={{
                                    margin: "6px 0 12px",
                                    fontSize: "14px",
                                    color: "#666",
                                    fontWeight: "500",
                                }}
                            >
                                Diretor de Operações
                            </p>

                            <Divider sx={{ margin: "12px 0" }} />

                            <ul
                                style={{
                                    paddingLeft: "18px",
                                    textAlign: "left",
                                    fontSize: "13.5px",
                                    color: "#444",
                                    lineHeight: "1.6",
                                }}
                            >
                                <li>Graduação em Ciências Contábeis – Universidade Federal do Paraná – UFPR.</li>
                                <li>MBA em Gestão Tributária – Universidade de São Paulo – USP.</li>
                                <li>MBA em Gestão Contábil e Tributária – Universidade Federal do Paraná – UFPR.</li>
                                <li>Discente de Especialização em Auditoria, Perícia e Planejamento Tributário – PUC/PR.</li>
                                <li>Formação de Consultores Tributários – ECONET.</li>
                                <li>Certificação em Gestão Financeira – Fundação Getúlio Vargas (FGV).</li>
                                <li>Certificação em Tributos Estaduais (ICMS/PR) – ECONET.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default Socios;